import { render, staticRenderFns } from "./SwaggerDoc.vue?vue&type=template&id=6cb3b814&scoped=true"
import script from "./SwaggerDoc.vue?vue&type=script&lang=js"
export * from "./SwaggerDoc.vue?vue&type=script&lang=js"
import style0 from "./SwaggerDoc.vue?vue&type=style&index=0&id=6cb3b814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb3b814",
  null
  
)

export default component.exports